import { useCallback, useState } from 'react';
import axios from 'axios';

import { DOWNLOAD_ERRORS } from './file-download.constants';

type UseS3LoaderParams = {
  filename: string;
  onError?: (error: unknown) => void;
};

export const useS3Loader = ({ filename, onError }: UseS3LoaderParams) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const download = useCallback(
    async (url: string) => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(url, { responseType: 'blob' });

        const href = window.URL.createObjectURL(response.data);
        const downloadLink = document.createElement('a');
        downloadLink.href = href;
        downloadLink.download = filename;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        window.URL.revokeObjectURL(href);
      } catch (err) {
        setError(DOWNLOAD_ERRORS.failed);
        onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [filename, onError],
  );

  return { download, loading, error };
};
